export default "https://assets.egbcdn.net/assets/packs/_/images/gift-box-a86c8d25ab5c2fc9d47dff8dd8258238.gif";